import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash-es';
import { PAGE_ADS_CUSTOM_TARGETING } from 'client/actions/constants';
import { updateVehicle, getVehicleFromInventoryVin } from 'client/actions/vehicle';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { IncentiveModel } from 'client/data/models/incentives';
import { InventoryModel, InventoryEntities } from 'client/data/models/inventory';
import { InventorySimilarVinsModel } from 'client/data/models/inventory-similar-vins';
import { VehicleModel, VehicleEntities } from 'client/data/models/vehicle';
import { VehicleModel as VehicleModelV2, buildTransactionCountPath } from 'client/data/models/vehicle-v2';
import { ConsumerReviewsModel, ConsumerReviewsPaths } from 'client/data/models/consumer-reviews';
import { PATHS as FinancingPaths, FinancingModel } from 'client/data/models/financing';
import { FeatureFlagModel } from 'client/data/models/feature-flag';
import { PageModel } from 'client/data/models/page';
import { UserProfileModel } from 'client/data/models/profile/profile';
import { DealerInfoModel } from 'client/data/models/dealer-info';
import { DigitalCheckoutModel, PATHS as DigitalCheckoutPaths } from 'client/data/models/digital-checkout';
import { PATHS, PrivateListingModel } from 'client/data/models/private-listing';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { legacyPageUpdate } from 'client/actions/legacy-page';
import { isUsed } from 'site-modules/shared/utils/inventory-utils/is-used';
import { isCpo } from 'site-modules/shared/utils/inventory-utils/is-cpo';
import { isNew } from 'site-modules/shared/utils/inventory-utils/is-new';
import { Storage } from 'site-modules/shared/utils/storage';
import { EdmundsCpaNoAdhesionDecorator } from 'client/site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { setAdsListToPreload } from 'client/site-modules/shared/components/native-ad/utils/utils';
import { INCENTIVES_AD, EAS_LISTING_AD } from 'client/site-modules/shared/components/native-ad/utils/constants';
import { TrackingHandler } from 'client/tracking/handler';
import { TrackingMap } from 'client/tracking/maps/inventory/vdp';
import { setCriticalCss } from 'client/actions/critical-css';
import { LARGE_VDP_WIDTH } from 'client/site-modules/shared/utils/inventory-image-utils';
import { getQuery } from 'client/utils/location';
import { isClientError } from 'client/utils/http-status';
import {
  compareMakeModelYearWithVin,
  get410Error,
  getVinPath,
  getVehiclePath,
  getVdpMeta,
  getVdpSeoObject,
  getInventoryListTrackingData,
  getIsNonTMVDealer,
} from 'site-modules/shared/utils/inventory/vdp-utils';
import { getInventoryHeroPhotoConfig } from 'site-modules/inventory/utils/get-inventory-hero-photo-config';
import {
  isCarZingPartner,
  isDriveway,
  isPartnerDealer,
  isPrivateParty,
} from 'site-modules/shared/utils/dealer-details-utils';
import { buildLeadTargetsPath, LeadTargetsModel } from 'client/data/models/lead-targets';
import { STRATEGIES } from 'site-modules/shared/constants/lead-form/lead-form-configs';
import { DATA_PATH } from 'client/engagement-handlers/inventory-engagement-handler/constants';
import { getPhoto360 } from 'site-modules/shared/utils/get-photo-360';
import { buildLeadTargetPreloadEnabled } from 'site-modules/shared/utils/inventory/build-lead-target-preload-enabled';
import { isCapOneProvider } from 'site-modules/shared/utils/financing/financing';
import { getEmbdLF } from 'site-modules/shared/utils/inventory/get-embd-lf';
import { isShowDeliveryDetails } from 'client/site-modules/shared/utils/is-show-delivery-details';
import { buildVinPhotosPath, PhotoflipperModel } from 'client/data/models/photoflipper';
import { buildDealerIcoWidgetConfigurationPath, DealerIcoWidgetModel } from 'client/data/models/dealer-ico-widget';
import { VisitorModel } from 'client/data/models/visitor';
import { isAvailableEnvToBypassApiGateway } from 'site-modules/shared/utils/financing/is-available-env-to-bypass-api-gateway';
import { hideEmbeddedLeadForm } from 'site-modules/shared/utils/lead-form/hide-embedded-lead-form';
import { getPromoView } from 'client/site-modules/inventory/utils/get-promo-view';
import {
  getConquestSimilarVinsParams,
  SearchFilterBuilder,
} from 'site-modules/shared/utils/inventory/get-conquest-similar-vins-params';

import { VdpWrapper } from './vdp';

export class Vdp extends Component {
  componentDidMount() {
    TrackingHandler.useMap(TrackingMap);
    this.storage = new Storage('sessionStorage');

    const { setModelValue, isMobile } = this.props;

    if (!isMobile && setModelValue) {
      setModelValue('isDesktop', InventoryModel, true);
    }
  }

  render() {
    const {
      vinData,
      isMobile,
      forceLease,
      isAuthenticated,
      vehicleData,
      radius,
      doNotSell,
      stateCode,
      isBLT2125DisableCarmax360,
      isBLT2125DisableSpinCar360,
      isSHOP413DisableFlickFusion360,
      isPrequalified,
      venomEnv,
      edmundsEnv,
      isCapOneBypassApiGateway,
      enableCaramel,
    } = this.props;
    if (!vinData) {
      return null;
    }
    const isCpoType = isCpo(vinData.type);
    const bestDealPrice =
      get(vinData, 'prices.edmundsSuggestedPriceIsCompliant') && get(vinData, 'prices.edmundsSuggestedPrice', 0);
    const advertisedPrice = get(vinData, 'prices.advertisedPrice', 0);
    const isNewVehicle = isNew(vinData.type);
    const showPriceAnalysisSection = bestDealPrice || advertisedPrice || isNewVehicle;
    const franchiseId = get(vinData, 'dealerInfo.franchiseId', '');
    const isNonTMVDealer = getIsNonTMVDealer(franchiseId);

    const listTrackingData = getInventoryListTrackingData({
      vinData,
      forceLease,
      isNonTMVDealer,
      isCpoType,
      radius,
      photo360: getPhoto360({
        vinData,
        doNotSell,
        isBLT2125DisableCarmax360,
        isBLT2125DisableSpinCar360,
        isSHOP413DisableFlickFusion360,
      }),
    });
    const isAllowBypassApiGateway =
      isAvailableEnvToBypassApiGateway({ venomEnv, edmundsEnv }) && isCapOneBypassApiGateway;

    return (
      <VdpWrapper
        listTrackingData={listTrackingData}
        vinData={vinData}
        vehicleData={vehicleData}
        isMobile={isMobile}
        forceLease={forceLease}
        isAuthenticated={isAuthenticated}
        isNonTMVDealer={isNonTMVDealer}
        showPriceAnalysisSection={!!showPriceAnalysisSection}
        radius={radius}
        doNotSell={doNotSell}
        stateCode={stateCode}
        isBLT2125DisableCarmax360={isBLT2125DisableCarmax360}
        isBLT2125DisableSpinCar360={isBLT2125DisableSpinCar360}
        isSHOP413DisableFlickFusion360={isSHOP413DisableFlickFusion360}
        isPrequalified={isPrequalified}
        isAllowBypassApiGateway={isAllowBypassApiGateway}
        enableCaramel={enableCaramel}
      />
    );
  }
}

Vdp.propTypes = {
  vinData: InventoryEntities.InventoryVin,
  vehicleData: VehicleEntities.MakeModelSubmodelYear,
  isMobile: PropTypes.bool,
  forceLease: PropTypes.bool,
  isAuthenticated: PropTypes.bool,
  radius: PropTypes.number,
  setModelValue: PropTypes.func,
  doNotSell: PropTypes.bool,
  stateCode: PropTypes.string,
  isBLT2125DisableCarmax360: PropTypes.bool,
  isBLT2125DisableSpinCar360: PropTypes.bool,
  isSHOP413DisableFlickFusion360: PropTypes.bool,
  isPrequalified: PropTypes.bool,
  venomEnv: PropTypes.string,
  edmundsEnv: PropTypes.string,
  isCapOneBypassApiGateway: PropTypes.bool,
  enableCaramel: PropTypes.bool,
};

Vdp.defaultProps = {
  vinData: null,
  vehicleData: null,
  isMobile: false,
  forceLease: false,
  isAuthenticated: false,
  radius: null,
  setModelValue: null,
  doNotSell: false,
  stateCode: null,
  isBLT2125DisableCarmax360: false,
  isBLT2125DisableSpinCar360: false,
  isSHOP413DisableFlickFusion360: false,
  isPrequalified: false,
  venomEnv: '',
  edmundsEnv: '',
  isCapOneBypassApiGateway: false,
  enableCaramel: false,
};

/**
 * Taking from redux state directly
 * @param state
 */
export const mapStateToProps = state => ({
  isMobile: state.mobile,
  isAuthenticated: state.profile.isAuthenticated,
  isBLT2125DisableCarmax360: !!get(state, 'featureFlags.blt-2125-disable-carmax-360'),
  isBLT2125DisableSpinCar360: !!get(state, 'featureFlags.blt-2125-disable-spincar-360'),
  isSHOP413DisableFlickFusion360: !!get(state, 'featureFlags["shop-413-disable-flickfusion-360"]'),
  venomEnv: state.venomEnv,
  edmundsEnv: state.edmundsEnv,
  isCapOneBypassApiGateway: !!get(state, 'featureFlags["capOneBypassApiGateway"]'),
  enableCaramel: !!get(state, 'featureFlags["enableCaramel"]'),
});

export const stateToPropsConfig = {
  vinData: bindToPath(({ params: { vin } }) => getVinPath(vin), InventoryModel, null, false),
  vehicleData: bindToPath(({ params: { make, model, year } }) => getVehiclePath(make, model, year), VehicleModel),
  isPageLoaded: bindToPath('loading.isLoaded', PageModel),
  profileData: {
    path: props => (props.isAuthenticated ? 'data.idm' : ''),
    segment: UserProfileModel,
  },
  isPrequalified: bindToPath(FinancingPaths.PREQUALIFICATION_DATA, FinancingModel, data => !!data),
  doNotSell: bindToPath('privacy.doNotSell', VisitorModel),
  stateCode: bindToPath('location.stateCode', VisitorModel),
};

export const VdpContainer = connect(mapStateToProps)(connectToModel(Vdp, stateToPropsConfig));

export const PageDefinitionConfiguration = params => ({
  ...getVdpMeta(),
  preload: async (store, props) => {
    const state = store.getState();
    const { mobile } = state;
    const { vin, model, year, make } = params;
    const preloader = new ModelPreloader(store);
    const vinPath = getVinPath(vin);
    const vehiclePath = getVehiclePath(make, model, year);
    const location = get(props, 'location', {});
    const query = getQuery(location);
    const enableCaramel = state.featureFlags?.enableCaramel;

    let modelState;

    if (!mobile) {
      preloader.set('isDesktop', InventoryModel, true);
    }

    preloader.resolve(vinPath, InventoryModel);
    preloader.resolve(vehiclePath, VehicleModel);
    preloader.resolve(buildVinPhotosPath({ vin }), PhotoflipperModel);
    preloader.resolve('location', VisitorModel);

    const radius = get(query, 'radius');
    const defaultRadius = 50;

    const isPrequalified = get(state, 'financing.prequalificationData');

    if (isPrequalified) {
      const isCapOneBypassApiGateway = get(state, 'featureFlags.capOneBypassApiGateway');
      const isAllowBypassApiGateway =
        isAvailableEnvToBypassApiGateway({
          venomEnv: get(state, 'venomEnv'),
          edmundsEnv: get(state, 'edmundsEnv'),
        }) && isCapOneBypassApiGateway;
      preloader.resolve(FinancingPaths.FINANCING_OFFERS({ vin, isAllowBypassApiGateway }), FinancingModel);
    }

    try {
      modelState = await preloader.load();
    } catch (error) {
      if (isClientError(error.status)) throw get410Error(vinPath);
      else throw error;
    }

    const vinData = modelState && modelState.get(vinPath, InventoryModel);
    const vinCode = get(vinData, 'vin');
    if (!vinCode || compareMakeModelYearWithVin(make, model, year, vinData)) {
      throw get410Error(vinPath);
    }
    const rooftopId = get(vinData, 'dealerInfo.rooftopId', '');
    const dealerZip = get(vinData, 'dealerInfo.address.zip', null);
    const type = get(vinData, 'type');
    const isUsedOrCpoVin = isUsed(type);

    const isPartner = isPartnerDealer(vinData);
    store.dispatch({
      type: PAGE_ADS_CUSTOM_TARGETING,
      adsCustomTargeting: {
        sect8: isPartner ? 'partner' : 'basic',
      },
    });

    const isPrivatePartyListing = isPrivateParty(vinData);
    if (isPrivatePartyListing && vinData?.stockNumber) {
      preloader.resolve(PATHS.LISTING_DATA({ listingId: vinData.stockNumber }), PrivateListingModel);
    }

    const isCapOne = isCapOneProvider(vinData);
    if (isCapOne && isPrequalified) {
      preloader.resolve(FinancingPaths.CALCULATOR_SELECTIONS({ vin }), FinancingModel);
    }

    if (enableCaramel && (isPrivatePartyListing || isUsedOrCpoVin)) {
      preloader.resolve(DigitalCheckoutPaths.DEALERS_WITHOUT_VALIDATION({ vin }), DigitalCheckoutModel);
    }

    const isUsedBasic = isUsed(vinData.type) && !isPartner;

    const pageMeta = getVdpMeta(type);

    // Save vehicle for the context, ads and tracking
    const vehicleData = modelState.get(vehiclePath, VehicleModel);
    store.dispatch(updateVehicle(getVehicleFromInventoryVin(vinData, vehicleData)));

    preloader.set(ConsumerReviewsPaths.getVehicleFilterPath(), ConsumerReviewsModel, {
      params: { make, model, year },
    });
    preloader.set(ConsumerReviewsPaths.getConsumerReviewsFilterPath(), ConsumerReviewsModel, {
      pagenum: 1,
      pagesize: 2, // Number of consumer reviews in component
    });

    // save page name
    store.dispatch(
      legacyPageUpdate({
        pageName: pageMeta.name,
        categoryName: pageMeta.category,
      })
    );

    const isCPOVehicle = isCpo(type);

    const vehiclePageContext = modelState.get('vehicle', PageModel);
    setAdsListToPreload(
      preloader,
      store.getState(),
      isUsedBasic ? new Set([INCENTIVES_AD.AD_NAME, EAS_LISTING_AD.AD_NAME]) : new Set([INCENTIVES_AD.AD_NAME]),
      vehiclePageContext
    );

    preloader.set('filters', InventorySimilarVinsModel, getConquestSimilarVinsParams(new SearchFilterBuilder(vinData)));

    if (!isPrivatePartyListing) {
      preloader.resolve(`dealerInfo.id.${rooftopId}`, DealerInfoModel);
    }
    preloader.set('incentivesZip', IncentiveModel, { zip: dealerZip });

    if (rooftopId) {
      preloader.resolve(
        buildDealerIcoWidgetConfigurationPath({
          rooftopId,
        }),
        DealerIcoWidgetModel
      );
      preloader.resolve(`carcodeConfig.${rooftopId}`, DealerInfoModel);
    }

    if (
      buildLeadTargetPreloadEnabled({
        vinData,
        isUsedBasic,
        location: get(props, 'location', {}),
      })
    ) {
      preloader.resolve(
        buildLeadTargetsPath({
          omitYear: true,
          omitStyleId: true,
          strategy: STRATEGIES.SINGLE,
          radius: radius ? Number(radius) : defaultRadius,
          vin,
        }),
        LeadTargetsModel
      );
    }

    const styleId = get(vinData, 'vehicleInfo.styleInfo.styleId', '');

    const isCarZingPrequalify = isUsed(type) && isCarZingPartner(vinData?.dealerInfo?.partnerCode);

    const isNewType = isNew(type);

    let inventoryType = type.toLowerCase();

    if (isCPOVehicle) {
      inventoryType = 'used';
    }

    if (isUsedBasic) {
      inventoryType = 'usedBasic';
    }

    const deliveryOptions = get(vinData, 'computedDisplayInfo.deliveryOptions');
    const deliveryCode = get(deliveryOptions, 'deliveryCode');
    const parentDealershipName = get(vinData, DATA_PATH.PARENT_DEALERSHIP_NAME, '');

    if (
      (isUsed(type) && isShowDeliveryDetails({ parentDealershipName, deliveryCode })) ||
      (isNewType && isPartner && isDriveway(parentDealershipName))
    ) {
      inventoryType = `${inventoryType}-dd`;
    }

    const promoView = getPromoView({ vinData, location: get(props, 'location', {}) });

    const showFabsWithPrice = isPartner && mobile && !isCarZingPrequalify;
    const disableInventoryMLPhotoSort = modelState.get('disable-inventory-ml-photo-sort', FeatureFlagModel);

    const { photoUrls, hasPhotos } = getInventoryHeroPhotoConfig({
      vinData,
      width: LARGE_VDP_WIDTH,
      disableInventoryMLPhotoSort,
    });
    const fabs = showFabsWithPrice ? 'fabs' : 'no-fabs'; // fabs stand for floating action buttons (ie. the sticky buttons at the bottom of the VDP)

    const isBLT2125DisableCarmax360 = modelState.get('blt-2125-disable-carmax-360', FeatureFlagModel);
    const isBLT2125DisableSpinCar360 = modelState.get('blt-2125-disable-spincar-360', FeatureFlagModel);
    const isSHOP413DisableFlickFusion360 = modelState.get('shop-413-disable-flickfusion-360', FeatureFlagModel);
    const disableDrivewayNewCarLeadForms = modelState.get('disableDrivewayNewCarLeadForms', FeatureFlagModel);

    let pfBtn = 'no';

    if (hasPhotos) {
      pfBtn = 'yes';

      const photo360 = getPhoto360({
        vinData,
        doNotSell: modelState.get('privacy.doNotSell', VisitorModel),
        isBLT2125DisableCarmax360,
        isBLT2125DisableSpinCar360,
        isSHOP413DisableFlickFusion360,
      });
      if (photo360) {
        pfBtn = '360';
      }

      const photoCount = photo360 ? photoUrls.length + 1 : photoUrls.length;
      if (photoCount > 1) {
        pfBtn = `${pfBtn}-swipe`;
      }
    }

    const inTransit = get(vinData, 'inTransit', false);
    const visitorLocation = modelState?.get('location', VisitorModel);

    /*
     * disable critical css if any of these are true:
     *   1. a user is prequalified for capital one
     *   2. the embedded lead form is hidden
     *   3. is private party listing
     */
    const disableCriticalCss =
      isPrequalified ||
      hideEmbeddedLeadForm({
        isVdp: true,
        isPartnerListing: isPartner,
        isUserSetZip: visitorLocation?.userSet,
        zipCode: visitorLocation?.zipCode,
        stateCode: visitorLocation.stateCode,
      }) ||
      isPrivatePartyListing;

    if (!disableCriticalCss) {
      let criticalCssHeight;
      if (mobile) {
        // increasing desktop height to include Check Availability when Cap One CTA is inserted above it
        criticalCssHeight = 2000;
      } else {
        // increasing desktop height to include longer right rail scenarios and full "Vehicle Summary.Highlights" section
        criticalCssHeight = 1600;
      }
      // 5 * 3 * 2 * 5 * 2 * 2  values = 600 values
      store.dispatch(
        setCriticalCss({
          criticalCssHeight,
          type: inventoryType, // 5 values: used, used-dd, new, usedBasic, usedBasic-dd
          promo: promoView, // 3 values: false, dropGraph, ratingGraph
          fabs, // 2 values: fabs, no-fabs
          pfBtn, // 5 values: no, yes, 360, yes-swipe, 360-swipe
          embdLF: getEmbdLF({ vinData, disableDrivewayNewCarLeadForms, location }), // 2 values: true, false
          msgTransit: isPartner && inTransit, // 2 values: true, false,
        })
      );
    } else {
      store.dispatch(setCriticalCss(false));
    }

    const preloadHeroImageAsset = {
      href: photoUrls[0],
      as: 'image',
    };

    preloader.set('server.preloadedAssets', PageModel, [preloadHeroImageAsset]);

    if (isNew(vinData.type) && styleId) {
      preloader.resolve(buildTransactionCountPath(styleId), VehicleModelV2);
    }

    return preloader.load();
  },
  seo: (state, props) => getVdpSeoObject(state, { ...props, params }),
  component: props => {
    const { location } = props;
    const query = getQuery(location);
    const forceLease = get(query, 'paymenttype', '') === 'lease';
    const radius = get(query, 'radius');

    return (
      <VdpContainer
        {...props}
        params={params}
        forceLease={forceLease}
        {...(radius ? { radius: Number(radius) } : {})}
      />
    );
  },
  decorator: EdmundsCpaNoAdhesionDecorator,
  options: {
    hasVehicleContext: true,
    adsSkipVehicleType: true,
  },
});
export default params => pageDefinition(PageDefinitionConfiguration(params));
